export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const USER_LOADED = "USER_LOADED";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_ERROR = "GET_ERROR";
export const CHANGE_PRICE = "CHANGE_PRICE";
export const GET_PRINTERS = "GET_PRINTERS";
export const DISABLE_PRINTER = "DISABLE_PRINTER";
export const EDIT_PRINTER = "EDIT_PRINTER";
export const CLEAR_PRINTER = "CLEAR_PRINTER";
export const CLEAR_PRODUCT = "CLEAR_PRODUCT";
export const GET_COUNTS = "GET_COUNTS";
export const DARK_MODE = "DARK_MODE";
export const GET_LOG = "GET_LOG";
export const GET_LOG_ERROR = "GET_LOG_ERROR";
export const CHANGE_LOADING = "CHANGE_LOADING";
export const INCOME_LOADING = "INCOME_LOADING";
export const INCOME_REPORT = "INCOME_REPORT";
export const INCOME_ERROR = "INCOME_ERROR";
export const REFUND = "REFUND";
export const REFUND_ERROR = "REFUND_ERROR";
export const EBARIMT_LOADING = "EBARIMT_LOADING";
export const CREATE_EBARIMT = "CREATE_EBARIMT";
export const CREATE_EBARIMT_ERROR = "CREATE_EBARIMT_ERROR";
export const DELETE_EBARIMT = "DELETE_EBARIMT";
export const SEND_EBARIMT = "SEND_EBARIMT";
export const GET_SATISFACTION = "GET_SATISFACTION";
export const GET_SATISFACTION_ERROR = "GET_SATISFACTION_ERROR";
export const SATISFACTION_LOADING = "SATISFACTION_LOADING";
export const GET_PRINT_ERRORS = "GET_PRINT_ERRORS";
export const GET_PRINT_ERRORS_ERROR = "GET_PRINT_ERRORS_ERROR";
export const PRINT_ERRORS_LOADING = "PRINT_ERRORS_LOADING";
export const RESOLVE_PRINT_ERROR = "RESOLVE_PRINT_ERROR";
export const PENDING_PRINT_ERRORS = "PENDING_PRINT_ERRORS";
export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATES_ERROR = "GET_TEMPLATES_ERROR";
export const TEMPLATES_LOADING = "TEMPLATES_LOADING";
export const GET_TEMPLATE_STATS = "GET_TEMPLATE_STATS";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const GET_ADMINS = "GET_ADMINS";
export const GET_ADMINS_ERROR = "GET_ADMINS_ERROR";
export const ADMINS_LOADING = "ADMINS_LOADING";
export const SAVE_ADMIN = "SAVE_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const SAVE_ROLE = "SAVE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
export const GET_TENANTS = "GET_TENANTS";
export const GET_TENANTS_ERROR = "GET_TENANTS_ERROR";
export const TENANTS_LOADING = "TENANTS_LOADING";
export const SAVE_TENANT = "SAVE_TENANT";
export const DELETE_TENANT = "DELETE_TENANT";
export const TENANT_REPORT = "TENANT_REPORT";
export const TENANT_REPORT_LOADING = "TENANT_REPORT_LOADING";
export const TENANT_REPORT_ERROR = "TENANT_REPORT_ERROR";
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR";
export const GET_ALERTS = "GET_ALERTS";
export const GET_ALERTS_ERROR = "GET_ALERTS_ERROR";
export const SAVE_ALERTS = "SAVE_ALERTS";
export const NEW_PARTNER_REQUESTS = "NEW_PARTNER_REQUESTS";
